<template>
    <div v-if="!isNodata">
        <div class="main-page">
            <div class="p-2.5 grid grid-cols-1 gap-1.5">
                <template v-for="(item, idx) in items" :key="`sr-item-${idx}`">
                    <SearchResultItem :item="item" :index="idx" @click="clickPlace(item)" />
                </template>
            </div>
        </div>

        <div class="bottom-nav">
            <div class="flex items-center gap-2 p-4 cursor-pointer" @click="clickOpenMap()">
                <img src="@/assets/icon/ic-pin-location.svg" alt=""/>
                <div class="text-12 text-a-black-484848 font-main font-light underline">
                    เลือกจากแผนที่
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <MainPage  pageTitle="ค้นหาอู่ , ศูนย์ซ่อม , โรงพยาบาลในเครือ" :bgClass="isNoData ? 'bg-white' : 'bg-a-gray-efefef'">
            <template v-if="isNodata">
                <NoData></NoData>
            </template>
        </MainPage>
    </div>
</template>

<script>
import { defineComponent, onMounted, provide, ref } from 'vue';
import useSearchService from '../service/useSearchService';
import SearchModel from '../model/SearchModel';
import { useRouter } from 'vue-router';
import ConfigManager from '@/config/ConfigManager';
import MapsService from '@/module/Maps/service/MapsService';
// component
import SearchResultItem from '../component/SearchResultItem.vue';
import NoData from '../component/NoData.vue';
import MainPage from '@/components/Layout/Page/MainPage.vue';

export default defineComponent({
    components: {
        SearchResultItem,
        NoData,
        MainPage
    },
    setup: function () {
        const router = useRouter()
        const items = ref([])
        const model = ref(new SearchModel())
        const searchService = useSearchService()
        const isNodata = ref(false)

        //#region google map
        const currentUserLocation = ref(null)
        const elemMap = ref(null);
        let googleKey = ConfigManager.getGoogleMapsKey();
        const mapService = MapsService(elemMap, {
            apiKey: googleKey,
            version: "weekly",
            libraries: ["places"]
        });
        mapService.getCurrentLocation().then((latLng) => {
            currentUserLocation.value = latLng
        })
        mapService.initMaps()

        provide("currentUserLocation", currentUserLocation)
        provide("mapService", mapService)
        //#endregion

        const clickPlace = function () {
            router.push({
                name: "dealer_detail"
            })
        }

        const clickOpenMap = function () {
            router.push({
                name: "dealer_maps"
            })
        }

        onMounted(() => {
            searchService.searchPlaces(model.value.getParams()).then((data) => {
                items.value = data;
                if (items.value.length == 0) {
                    isNodata.value = true
                }
            })
        })

        return {
            items,
            clickPlace,
            clickOpenMap,
            isNodata
        }
    },
})
</script>

<style lang="scss" scoped>
.main-page {
    padding-bottom: 52px;
    @apply mx-auto flex flex-col w-full min-h-screen bg-a-gray-efefef font-main max-w-lg;
}

.bottom-nav {
    box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.16);
    height: 52px;
    @apply fixed left-0 right-0 bottom-0 w-full bg-white max-w-lg mx-auto rounded-t-10 flex flex-col items-center justify-center;
}
</style>
